import moment from 'moment';
import store from 'store';

const savedTempType = store.get('_weather-temp-type');

export const forecast = 'BRXX0201';
export const timezone = 'America/Sao_Paulo|LMT BRT BRST|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6';
export const useCelsius = savedTempType ? savedTempType === 'celsius' : /^edition\./.test(window.location.hostname);
export const startDate = moment('2016-08-05');
export const endDate = moment('2016-08-21');
export const apiBaseUrl = '//data.cnn.com/olympics/2016';
export const hubPageUrl = 'http://edition.cnn.com/sport/olympics';

// Poll for new content every 30 seconds
export const dataRefreshTime = 30000;

export const disciplines = [
	'Archery',
	'Artistic Gymnastics',
	'Athletics',
	'Badminton',
	'Basketball',
	'Beach Volleyball',
	'Boxing',
	'Canoe Slalom',
	'Canoe Sprint',
	'Cycling BMX',
	'Cycling Mountain Bike',
	'Cycling Road',
	'Cycling Track',
	'Diving',
	'Equestrian',
	'Fencing',
	'Football',
	'Golf',
	'Handball',
	'Hockey',
	'Judo',
	'Marathon Swimming',
	'Modern Pentathlon',
	'Rhythmic Gymnastics',
	'Rowing',
	'Rugby Sevens',
	'Sailing',
	'Shooting',
	'Swimming',
	'Synchronised Swimming',
	'Table Tennis',
	'Taekwondo',
	'Tennis',
	'Trampoline Gymnastics',
	'Triathlon',
	'Volleyball',
	'Water Polo',
	'Weightlifting',
	'Wrestling'
];



/** WEBPACK FOOTER **
 ** ./scripts/config.es6
 **/